export enum RenderCellTypes {
  BUTTON = "BUTTON",
  BUTTON_WITH_RESULT_STATUS = "BUTTON_WITH_RESULT_STATUS",
  /** Underlined text button + copy icon (e.g. lead details with nurturing on text click). */
  BUTTON_WITH_COPY = "BUTTON_WITH_COPY",
  BUTTON_WITH_ICON = "BUTTON_WITH_ICON",
  TEXT = "TEXT",
  TEXT_WITH_COPY = "TEXT_WITH_COPY",
  NUMBER = "NUMBER",
  STATUS = "STATUS",
  INFO_TOOLTIP = "INFO_TOOLTIP",
  POPOVER_INFO = "POPOVER_INFO",
  DATE = "DATE",
  TIME = "TIME",
  DATETIME = "DATETIME",
  DATETIME_UTC = "DATETIME_UTC",
  /** Date+time formatted in dealer-selected timezone with TZ abbreviation (e.g. EDT). */
  DATETIME_DEALER = "DATETIME_DEALER",
  NUMBER_PERCENT = "NUMBER_PERCENT",
  COUNT_WITH_ICON = "COUNT_WITH_ICON",
  BUTTON_WITH_ACTION_ICONS = "BUTTON_WITH_ACTION_ICONS",
  TEST_NURTURING_AUTOMATION_STATUS = "TEST_NURTURING_AUTOMATION_STATUS",
  ACTION_BUTTONS = "ACTION_BUTTONS",
  OFFER_ACTIONS = "OFFER_ACTIONS",
  RUN_LOG_STATUS_WITH_RETRY = "RUN_LOG_STATUS_WITH_RETRY",
  OFFER_HEADLINE = "OFFER_HEADLINE",
  OFFER_ACTIVE_TOGGLE = "OFFER_ACTIVE_TOGGLE",
  EMAIL_TEMPLATE_ACTIONS = "EMAIL_TEMPLATE_ACTIONS",
  HIL_TEMPLATE_ACTIONS = "HIL_TEMPLATE_ACTIONS",
  HIL_TEMPLATE_GENERATED_TYPE = "HIL_TEMPLATE_GENERATED_TYPE",
  HIL_SEGMENTS_ATTENTION_ACTIONS = "HIL_SEGMENTS_ATTENTION_ACTIONS",
  /** Template row: display `metadata["segment name"]` (and fallbacks) in a synthetic `segment` column. */
  EMAIL_TEMPLATE_SEGMENT_NAME = "EMAIL_TEMPLATE_SEGMENT_NAME",
  EMAIL_TEMPLATE_STATUS_DROPDOWN = "EMAIL_TEMPLATE_STATUS_DROPDOWN",
  RATE = "RATE",
  IMAGE = "IMAGE",
  CHIP_ARRAY = "CHIP_ARRAY",
  METADATA_MODAL = "METADATA_MODAL",
  RESOURCE_NAME = "RESOURCE_NAME",
}
